import { render, staticRenderFns } from "./registraion.vue?vue&type=template&id=0eac1315&"
import script from "./registraion.vue?vue&type=script&lang=js&"
export * from "./registraion.vue?vue&type=script&lang=js&"
import style0 from "./registraion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports